<template>
  <div class='invalid'>
    <div class="wrap">
      <img src="static/svgs/cogniclick-logo.svg" alt="Cogniclick">
      <p><i class="icon ion-md-alert"></i> Invalid theme</p>
      <p>{{ validateConfig.errors.join(', ') }}</p>
      <p><a v-on:click='reload'>Click to reload</a></p>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    reload () {
      let url = location.protocol + '//' + location.host + location.pathname
      window.location.href = url
    }
  }
}
</script>
<style lang='scss' scoped>
  .invalid {
    background-color: #333;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    width: 100%;
    .wrap {
      flex: 0 0 20%;
      width: 33%;
      margin: auto;
      max-width: 400px;
      color: #efefef;
      text-align: center;
    }
    ul {
      padding: 0;
      list-style-type: none;
    }
  }
</style>
